import { Button } from '@library/components/buttons';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import type { CustomRoutes } from '@bo-types/Router';
import { NavLink } from 'react-router-dom';
import { cn } from '@library/component-utils/cn';
import { useState } from 'react';

export interface LinkGroupProps {
  groupName: string;
  routes: CustomRoutes;
}

export const LinkGroup = ({ groupName, routes }: LinkGroupProps) => {
  const [showLinks, setShowLinks] = useState(true);

  const handleToggleLinks = () => {
    setShowLinks(!showLinks);
  };

  const links = routes.map((route) => {
    const { exact = false, path, title } = route;

    return (
      <NavLink
        className={({ isActive }) =>
          cn(
            isActive ? 'bg-soFresh-130' : '',
            'hover:bg-soFresh-130 hover:text-soClean-100 block rounded-md py-3 text-xs font-normal leading-4'
          )
        }
        end={exact}
        key={path}
        to={path || '/'}
        title={title}
      >
        {({ isActive }) => (
          <div className="flex items-center">
            {isActive && (
              <div className="bg-stankonia-100 h-4 w-2 rounded-r-md" />
            )}
            <span className={isActive ? 'pl-2' : 'pl-4'}>{title}</span>
          </div>
        )}
      </NavLink>
    );
  });

  return (
    <div className="text-[10px] leading-5">
      <div className="text-soClean-180 grid grid-cols-[1fr_1rem] py-2 pl-2 font-bold uppercase leading-5 tracking-[0.33px]">
        <h2>{groupName}</h2>
        <Button
          type="button"
          title="ToggleLinkGroupsButton"
          onClick={handleToggleLinks}
        >
          <ChevronDownIcon
            className={cn(showLinks ? '' : 'rotate-270', 'size-3')}
          />
        </Button>
      </div>
      {showLinks && links}
    </div>
  );
};
